import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/mail-inv.svg")